import validate from "/home/bede/bede-web/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.0_@types+node@22.13.10_db0@0.3.1_encoding@0.1.13_ioredi_a0c24836089298352991004b3cb229ec/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/bede/bede-web/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.0_@types+node@22.13.10_db0@0.3.1_encoding@0.1.13_ioredi_a0c24836089298352991004b3cb229ec/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "vuefire-authenticated": () => import("/home/bede/bede-web/middleware/vuefire-authenticated.ts")
}